
import { Component, Mixins, Watch } from "vue-property-decorator";
import mixin from "./mixin";
import { getModule } from "vuex-module-decorators";
import StockOrderModule from "@/store/modules/barcodeSystem/stockOrder";
import * as modals from "@/lib/modals";

@Component({
  name: modals.unlockStockOrderModal
})
export default class UnlockStockOrderModal extends Mixins(mixin) {
  stockOrderModule: StockOrderModule = getModule(StockOrderModule);

  async unlock() {
    this.isLoading = true;
    for (let index = 0; index < this.selectedItems.length; index++) {
      let stockOrder = this.selectedItems[index];

      try {
        await this.stockOrderModule.unlockStockOrder(stockOrder);
        this.addActionResult({
          number: stockOrder.id,
          success: true,
          message: `Stock Order ${stockOrder.crn} successfully unlocked.`
        });
      } catch (error) {
        this.addActionResult({
          number: stockOrder.id,
          success: false,
          message: error.response.data.message,
          errors:
            error.response.data && error.response.data.errors ? error.response.data.errors : null,
          errorMessages:
            error.response.data && error.response.data.errorMessages
              ? error.response.data.errorMessages
              : null
        });
      }
    }
    await this.refreshStockOrders();
    this.hideModal();
  }

  async refreshStockOrders(){
    await this.stockOrderModule.updateStockOrdersAfterAction(this.selectedItems);
  }
}
